<template>
  <a-page
    :image_source="image_source"
    :image_height="image_height"
    :color="isGroup ? '#ffffff' : '#f1f1f1'"
  >
    <template v-slot:header_options>
      <a-rms-range-selector
        v-if="!isGroup"
        ref="a-rms-range-selector"
        :event_period="[revenue_from, revenue_to]"
        :previous_months="true"
        @updatePeriod="updateRange"
        class="mr-2 mt-2"
      >
      </a-rms-range-selector>
      <a-rms-vs-selector-single
        v-if="!isGroup"
        :current_vs="revenue_vs"
        @updateVs="updateVs"
        dark
        class="mr-2 mt-2"
      ></a-rms-vs-selector-single>
      <a-rms-import-dates
        ref="rms_import_dates"
        v-if="!isGroup"
        class="mt-2"
      ></a-rms-import-dates>
    </template>
    <a-hotel-selector-rms
      ref="a-hotel-selector-rms"
      v-if="isGroup"
    ></a-hotel-selector-rms>
    <rms-revenue-app
      v-else
      ref="rms-revenue-app"
      :event_period="[revenue_from, revenue_to]"
      :is_previous_date="is_previous_date"
    ></rms-revenue-app>
  </a-page>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import aPage from "@/components/aPage";
import rmsRevenueApp from "@/components/app/rmsRevenueApp";
import aRmsRangeSelector from "@/components/rms/aRmsRangeSelector";
import aHotelSelectorRms from "@/components/selector/aHotelSelectorRms";
import aRmsVsSelectorSingle from "@/components/rms/aRmsVsSelectorSingle";
import aRmsImportDates from "@/components/rms/aRmsImportDates";

export default {
  name: "rms-revenue",
  components: {
    aPage,
    rmsRevenueApp,
    aRmsRangeSelector,
    aHotelSelectorRms,
    aRmsVsSelectorSingle,
    aRmsImportDates
  },
  data: () => ({
    image_source: "/img/header.jpg"
  }),
  methods: {
    updateRange(v) {
      let range = JSON.parse(JSON.stringify(v));
      this.revenue_from = range[0];
      this.revenue_to = range[1];
    },
    updateVs(v) {
      this.revenue_vs = v;
    }
  },
  computed: {
    isGroup() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    image_height() {
      return !this.isGroup ? 150 : 200;
    },
    is_previous_date() {
      return this.revenue_to < Vue.moment().format("YYYY-MM-DD");
    },
    revenue_from: {
      get() {
        return this.$store.state.rms.revenue_from;
      },
      set(value) {
        this.$store.dispatch("setRevenueFrom", value);
      }
    },
    revenue_to: {
      get() {
        return this.$store.state.rms.revenue_to;
      },
      set(value) {
        this.$store.dispatch("setRevenueTo", value);
      }
    },
    revenue_vs: {
      get() {
        return this.$store.state.rms.revenue_vs;
      },
      set(value) {
        this.$store.dispatch("setRevenueVs", value);
      }
    },
    ...mapState({
      available_permissions: state => state.user.available_permissions
    }),
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  mounted() {
    // Initialize selector
    this.revenue_from = Vue.moment()
      .startOf("month")
      .add(-1, "month")
      .format("YYYY-MM-DD");
    this.revenue_to = Vue.moment()
      .endOf("month")
      .add(-1, "month")
      .format("YYYY-MM-DD");
    this.revenue_vs = "stly";
  }
};
</script>
